import React from 'react';

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="dark-section" style={{ padding: '64px 0 48px' }}>
      <div className="container">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 style={{ marginTop: 12 }}>{title}</h1>
        {subtitle && <p style={{ maxWidth: 640, fontSize: '1.05rem' }}>{subtitle}</p>}
      </div>
    </section>
  );
}
